import {ProductMapper} from "@app/core/product/infrastructure/mappers/product.mapper";
import {ListDetail} from "../../domain/list-detail";

export class ListDetailMapper {
    static deserialize(param: any): ListDetail {
        return new ListDetail({
            products: param.products.map(ProductMapper.deserialize),
            name: param.name,
            finalPrice: param.finalPrice,
            taxes: param.taxes,
            items: param.items,
            totalPallets: param.totalPalets,
            totalPrice: param.totalPrice,
            couponImport: param.couponImport,
        })
    }
}
